import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "download-file",
  "use": "download-file-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"download-file\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.91054 7.84405L11.2105 4.5441L12.2856 5.61842L7.14279 10.7612L2 5.61842L3.07503 4.5441L6.37498 7.84405V0.0921021H7.91054V7.84405ZM11.3638 12.373H2.92102V13.9079H11.3638V12.373Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol